import { render, staticRenderFns } from "./AddUserGroupTransfer.vue?vue&type=template&id=ae53cade&"
import script from "./AddUserGroupTransfer.vue?vue&type=script&lang=js&"
export * from "./AddUserGroupTransfer.vue?vue&type=script&lang=js&"
import style0 from "./AddUserGroupTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports